var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "inputPanel",
        class: { inputPanel__error: _vm.invalidFields.franking_contract }
      },
      [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "inputPanel__col inputPanel__input" }, [
          _c("ul", { staticClass: "toggleBtns toggleBtns--fullWidth" }, [
            _c("li", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.franking_contract,
                    expression: "franking_contract"
                  }
                ],
                attrs: {
                  type: "radio",
                  id: "byes",
                  name: "underlease",
                  value: "yes"
                },
                domProps: { checked: _vm._q(_vm.franking_contract, "yes") },
                on: {
                  change: function($event) {
                    _vm.franking_contract = "yes"
                  }
                }
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "byes" } }, [_vm._v("yes")])
            ]),
            _vm._v(" "),
            _c("li", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.franking_contract,
                    expression: "franking_contract"
                  }
                ],
                attrs: {
                  type: "radio",
                  id: "bleaseexpired",
                  name: "underlease",
                  value: "no_lease_expired"
                },
                domProps: {
                  checked: _vm._q(_vm.franking_contract, "no_lease_expired")
                },
                on: {
                  change: function($event) {
                    _vm.franking_contract = "no_lease_expired"
                  }
                }
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "bleaseexpired" } }, [
                _vm._v("no the lease has expired")
              ])
            ]),
            _vm._v(" "),
            _c("li", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.franking_contract,
                    expression: "franking_contract"
                  }
                ],
                attrs: {
                  type: "radio",
                  id: "bnopurchased",
                  name: "underlease",
                  value: "no_purchased"
                },
                domProps: {
                  checked: _vm._q(_vm.franking_contract, "no_purchased")
                },
                on: {
                  change: function($event) {
                    _vm.franking_contract = "no_purchased"
                  }
                }
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "bnopurchased" } }, [
                _vm._v("no its purchased")
              ])
            ]),
            _vm._v(" "),
            _c("li", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.franking_contract,
                    expression: "franking_contract"
                  }
                ],
                attrs: {
                  type: "radio",
                  id: "bidontknow",
                  name: "underlease",
                  value: "dont_know"
                },
                domProps: {
                  checked: _vm._q(_vm.franking_contract, "dont_know")
                },
                on: {
                  change: function($event) {
                    _vm.franking_contract = "dont_know"
                  }
                }
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "bidontknow" } }, [
                _vm._v("i don't know")
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("error-modal", [
          _vm._v(
            "\n      If you are unsure whether the current equipment is leased or owned the best way to check is to review your latest invoice/s. Purchased equipment will typically be invoiced for service/maintenance annually only, whereas leased/rented equipment will be invoiced, monthly, quarterly or annually and will confirm the lease/rental costs seperately from the service costs.\n      "
          ),
          _c("br"),
          _c("br"),
          _c("b", [
            _vm._v("Having issues confirming or don't have the time to review?")
          ]),
          _c("br"),
          _vm._v(
            "\n      **We offer a service whereby on your consent we will gather all necessary information and detail on your behalf. "
          ),
          _c(
            "a",
            {
              attrs: {
                href: "https://themailingexpert.com/let-us-do-it-for-you/",
                target: "_blank"
              }
            },
            [_vm._v("Click here")]
          ),
          _vm._v(
            " to understand more and to request this free service.**\n    "
          )
        ]),
        _vm._v(" "),
        _c("info-modal", [
          _vm._v(
            "\n      If you are unsure whether the current equipment is leased or owned the best way to check is to review your latest invoice/s. Purchased equipment will typically be invoiced for service/maintenance annually only, whereas leased/rented equipment will be invoiced, monthly, quarterly or annually and will confirm the lease/rental costs seperately from the service costs.\n      "
          ),
          _c("br"),
          _c("br"),
          _c("b", [
            _vm._v("Having issues confirming or don't have a time to review:")
          ]),
          _c("br"),
          _vm._v(
            "\n      **We offer a service whereby on your consent we will gather all necessary information and detail on your behalf. "
          ),
          _c(
            "a",
            {
              attrs: {
                href: "https://themailingexpert.com/let-us-do-it-for-you/",
                target: "_blank"
              }
            },
            [_vm._v("Click here")]
          ),
          _vm._v(
            " to understand more and to request this free service.**\n    "
          )
        ])
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "inputPanel",
        class: { inputPanel__error: _vm.invalidFields.franking_indicia }
      },
      [
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "inputPanel__col inputPanel__input" }, [
          _c(
            "ul",
            {
              staticClass:
                "toggleBtns toggleBtns--fullWidth toggleBtns--withImg"
            },
            [
              _c("li", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.franking_indicia,
                      expression: "franking_indicia"
                    }
                  ],
                  attrs: {
                    type: "radio",
                    id: "towncircle",
                    name: "indicia",
                    value: "town_circle"
                  },
                  domProps: {
                    checked: _vm._q(_vm.franking_indicia, "town_circle")
                  },
                  on: {
                    change: function($event) {
                      _vm.franking_indicia = "town_circle"
                    }
                  }
                }),
                _vm._v(" "),
                _vm._m(2)
              ]),
              _vm._v(" "),
              _c("li", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.franking_indicia,
                      expression: "franking_indicia"
                    }
                  ],
                  attrs: {
                    type: "radio",
                    id: "mailmark",
                    name: "indicia",
                    value: "mailmark"
                  },
                  domProps: {
                    checked: _vm._q(_vm.franking_indicia, "mailmark")
                  },
                  on: {
                    change: function($event) {
                      _vm.franking_indicia = "mailmark"
                    }
                  }
                }),
                _vm._v(" "),
                _vm._m(3)
              ]),
              _vm._v(" "),
              _c("li")
            ]
          )
        ]),
        _vm._v(" "),
        _c("error-modal", [
          _vm._v(
            "\n      Its important we understand what franking indicia type you currently use, as this helps us to confirm your anticipated postage savings. If you are unsure the best way to check is to look at a print from your franking machine. If your machine was acquired prior to 2014 chances are it isn't MailMark. You can always "
          ),
          _c("b", [_vm._v("'Live Chat'")]),
          _vm._v("\n      or "),
          _c("b", [
            _vm._v("'"),
            _c(
              "a",
              {
                attrs: {
                  href: "https://themailingexpert.com/contact-us/",
                  target: "_blank"
                }
              },
              [_vm._v("contact us")]
            ),
            _vm._v("'")
          ]),
          _vm._v(
            " for guidance and we will quickly and easily help you determine this.\n    "
          )
        ]),
        _vm._v(" "),
        _c("info-modal", [
          _vm._v(
            "\n      Its important we understand what Franking indicia type you currently use, as this helps us to confirm your anticipated postage savings. If you are unsure the best way to check is to look at a print from your franking machine. If your machine was acquired prior to 2014 chances are it isn't MailMark. You can always "
          ),
          _c("b", [_vm._v("'Live Chat'")]),
          _vm._v("\n      or "),
          _c("b", [
            _vm._v("'"),
            _c(
              "a",
              {
                attrs: {
                  href: "https://themailingexpert.com/contact-us/",
                  target: "_blank"
                }
              },
              [_vm._v("contact us")]
            ),
            _vm._v("'")
          ]),
          _vm._v(
            " for guidance and we will quickly and easily help you determine this.\n    "
          )
        ])
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "inputPanel",
        class: { inputPanel__error: _vm.invalidFields.franking_postage_payment }
      },
      [
        _vm._m(4),
        _vm._v(" "),
        _c("div", { staticClass: "inputPanel__col inputPanel__input" }, [
          _c("ul", { staticClass: "toggleBtns toggleBtns--inline" }, [
            _c("li", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.franking_postage_payment,
                    expression: "franking_postage_payment"
                  }
                ],
                attrs: {
                  type: "radio",
                  id: "advanced",
                  name: "payforpostage",
                  value: "advanced"
                },
                domProps: {
                  checked: _vm._q(_vm.franking_postage_payment, "advanced")
                },
                on: {
                  change: function($event) {
                    _vm.franking_postage_payment = "advanced"
                  }
                }
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "advanced" } }, [_vm._v("advance")])
            ]),
            _vm._v(" "),
            _c("li", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.franking_postage_payment,
                    expression: "franking_postage_payment"
                  }
                ],
                attrs: {
                  type: "radio",
                  id: "arrears",
                  name: "payforpostage",
                  value: "arrears"
                },
                domProps: {
                  checked: _vm._q(_vm.franking_postage_payment, "arrears")
                },
                on: {
                  change: function($event) {
                    _vm.franking_postage_payment = "arrears"
                  }
                }
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "arrears" } }, [_vm._v("arrears")])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("error-modal", [
          _c("b", [_vm._v("Payment in arrears:")]),
          _c("br"),
          _vm._v(
            "\n\n      This service is only available through Pitney Bowes and Quadient (Neopost) at this time.\n\n      This service allows businesses to top up franking machines, pulling funds from an agreed credit limit. Rather than an invoice for every postage top up/refill a monthly statement covering all transactions during that monthly billing period is instead sent. This service typically carries higher recrediting fees but reduces the number of invoices to one consolidated monthly statement and means your business doesn't have funds tied up and sitting in a holding account.\n\n      Pitney Bowes payment in arrears service is called Purchase Power.\n\n      Quadient (Neopost) is called Neofunds.\n\n      "
          ),
          _c("br"),
          _c("br"),
          _c("b", [_vm._v("Payment in advance")]),
          _c("br"),
          _vm._v(
            "\n\n      The payment in advance services are available from all manufacturers and require your business to prepay into a deposit/holding account. When your franking machine is refilled/topped up funds will be drawn down from your account.\n\n      For each top up/refill transaction your business will be invoiced for each transaction, plus any associated reset/recrediting charges. On payment of this invoice your holding/deposit account is replenished to the agreed balance ensuring you have suitable funds available for when you next need to top up.\n    "
          )
        ]),
        _vm._v(" "),
        _c("info-modal", [
          _c("b", [_vm._v("Payment in arrears:")]),
          _c("br"),
          _vm._v(
            "\n\n      This service is only available through Pitney Bowes and Quadient (Neopost) at this time.\n\n      This service allows businesses to top up franking machines, pulling funds from an agreed credit limit. Rather than an invoice for every postage top up/refill a monthly statement covering all transactions during that monthly billing period is instead sent. This service typically carries higher recrediting fees but reduces the number of invoices to one consolidated monthly statement and means your business doesn't have funds tied up and sitting in a holding account.\n\n      Pitney Bowes payment in arrears service is called Purchase Power.\n\n      Quadient (Neopost) is called Neofunds.\n\n      "
          ),
          _c("br"),
          _c("br"),
          _c("b", [_vm._v("Payment in advance")]),
          _c("br"),
          _vm._v(
            "\n\n      The payment in advance services are available from all manufacturers and require your business to prepay into a deposit/holding account. When your franking machine is refilled/topped up funds will be drawn down from your account.\n\n      For each top up/refill transaction your business will be invoiced for each transaction, plus any associated reset/recrediting charges. On payment of this invoice your holding/deposit account is replenished to the agreed balance ensuring you have suitable funds available for when you next need to top up.\n    "
          )
        ])
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "inputPanel",
        class: { inputPanel__error: _vm.invalidFields.printer_model_id }
      },
      [
        _vm._m(5),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "inputPanel__col inputPanel__input inputPanel__input--groupFull inputPanel__input--selectaproduct"
          },
          [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.selectedManufacturer,
                    expression: "selectedManufacturer"
                  }
                ],
                attrs: { name: "currentmanone" },
                on: {
                  change: function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.selectedManufacturer = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  }
                }
              },
              [
                _c("option", { attrs: { disabled: "", value: "null" } }, [
                  _vm._v("Please Select")
                ]),
                _vm._v(" "),
                _vm._l(_vm.manufacturers, function(manufacturer) {
                  return _vm.canSelectManufacturer(manufacturer.id)
                    ? _c("option", { domProps: { value: manufacturer.id } }, [
                        _vm._v(_vm._s(manufacturer.name))
                      ])
                    : _vm._e()
                })
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.printer_model_id,
                    expression: "printer_model_id"
                  }
                ],
                attrs: { name: "currentmantwo" },
                on: {
                  change: function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.printer_model_id = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  }
                }
              },
              [
                _c("option", { attrs: { disabled: "", value: "null" } }, [
                  _vm._v("Please Select")
                ]),
                _vm._v(" "),
                _vm._l(_vm.printers, function(printer) {
                  return _c("option", { domProps: { value: printer.id } }, [
                    _vm._v(_vm._s(printer.model))
                  ])
                })
              ],
              2
            ),
            _vm._v(" "),
            _vm.printerImage
              ? _c(
                  "div",
                  {
                    staticClass: "box box--image",
                    staticStyle: { width: "100%" }
                  },
                  [
                    _c("img", {
                      staticStyle: { width: "100%", height: "auto" },
                      attrs: { src: _vm.printerImage, alt: "" }
                    })
                  ]
                )
              : _vm._e()
          ]
        ),
        _vm._v(" "),
        _c("error-modal", [
          _vm._v(
            "\n      If you are unsure of the model of your machine use the image selection to help you to confirm, or 'live chat', '"
          ),
          _c("a", { attrs: { href: "tel:0330 124 1977" } }, [_vm._v("call")]),
          _vm._v("' or '"),
          _c(
            "a",
            { attrs: { href: "mailto:customerservices@themailingexpert.com" } },
            [_vm._v("email")]
          ),
          _vm._v(
            "' with us and we can help confirm what model you should be selecting. Some resellers rename models varying them from original manufacturer name but we can help demystify this for you.\n    "
          )
        ]),
        _vm._v(" "),
        _c("info-modal", [
          _vm._v(
            "\n      If you are unsure of the model of your machine use the image selection to help you to confirm, or 'Live chat', '"
          ),
          _c("a", { attrs: { href: "tel:0330 124 1977" } }, [_vm._v("Call")]),
          _vm._v("' or '"),
          _c(
            "a",
            { attrs: { href: "mailto:customerservices@themailingexpert.com" } },
            [_vm._v("email")]
          ),
          _vm._v(
            "' with us and we can help confirm what model you should be selecting. Some resellers rename models varying them from original manufacturer name but we can help demystify this for you.\n    "
          )
        ])
      ],
      1
    ),
    _vm._v(" "),
    _vm.selectedManufacturer === 3
      ? _c(
          "div",
          {
            staticClass: "inputPanel",
            class: {
              inputPanel__error: _vm.invalidFields.franking_quadient_plan
            }
          },
          [
            _vm._m(6),
            _vm._v(" "),
            _c("div", { staticClass: "inputPanel__col inputPanel__input" }, [
              _c("ul", { staticClass: "toggleBtns toggleBtns--fullWidth" }, [
                _c("li", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.franking_quadient_plan,
                        expression: "franking_quadient_plan"
                      }
                    ],
                    attrs: {
                      type: "radio",
                      id: "essentialcare",
                      name: "quadient",
                      value: "essential_care"
                    },
                    domProps: {
                      checked: _vm._q(
                        _vm.franking_quadient_plan,
                        "essential_care"
                      )
                    },
                    on: {
                      change: function($event) {
                        _vm.franking_quadient_plan = "essential_care"
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "essentialcare" } }, [
                    _vm._v("Essential Care")
                  ])
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.franking_quadient_plan,
                        expression: "franking_quadient_plan"
                      }
                    ],
                    attrs: {
                      type: "radio",
                      id: "totalcare",
                      name: "quadient",
                      value: "total_care"
                    },
                    domProps: {
                      checked: _vm._q(_vm.franking_quadient_plan, "total_care")
                    },
                    on: {
                      change: function($event) {
                        _vm.franking_quadient_plan = "total_care"
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "totalcare" } }, [
                    _vm._v(
                      "Total Care – Includes 6 Hour Response And Reduced Fee For Neofund Recrediting"
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.franking_quadient_plan,
                        expression: "franking_quadient_plan"
                      }
                    ],
                    attrs: {
                      type: "radio",
                      id: "idontknowc",
                      name: "quadient",
                      value: "dont_know"
                    },
                    domProps: {
                      checked: _vm._q(_vm.franking_quadient_plan, "dont_know")
                    },
                    on: {
                      change: function($event) {
                        _vm.franking_quadient_plan = "dont_know"
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "idontknowc" } }, [
                    _vm._v("i don't know")
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("error-modal", [
              _vm._v(
                "\n      Quadient (Neopost) offers two main types of service cover, 'Essential Care' and 'TotalCare'. The main differences between them are that Essential care is an 8 hour response SLA with higher postage recredit charges in comparison to TotalCare which has a 6 hour response SLA with lower recrediting fees. If you are unsure of which service you have please select 'Essential Care' or 'I Don't Know' and we will base the quote and savings on the most conservative rate to ensure we over deliver on savings.\n    "
              )
            ]),
            _vm._v(" "),
            _c("info-modal", [
              _vm._v(
                "\n      Quadient (Neopost) offers two main types of service cover, 'Essential Care' and 'TotalCare'. The main differences between them are that Essential care is an 8 hour response SLA with higher postage recredit charges in comparison to TotalCare which has a 6 hour response SLA with lower recrediting fees. If you are unsure of which service you have please select 'Essential Care' or 'I Don't Know' and we will base the quote and savings on the most conservative rate to ensure we over deliver on savings.\n    "
              )
            ])
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "inputPanel",
        class: { inputPanel__error: _vm.invalidFields.franking_quote_type }
      },
      [
        _vm._m(7),
        _vm._v(" "),
        _c("div", { staticClass: "inputPanel__col inputPanel__input" }, [
          _c("ul", { staticClass: "toggleBtns toggleBtns--fullWidth" }, [
            _c("li", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.franking_quote_type,
                    expression: "franking_quote_type"
                  }
                ],
                attrs: {
                  type: "radio",
                  id: "likeforlike",
                  name: "quoterequirements",
                  value: "like_for_like"
                },
                domProps: {
                  checked: _vm._q(_vm.franking_quote_type, "like_for_like")
                },
                on: {
                  change: function($event) {
                    _vm.franking_quote_type = "like_for_like"
                  }
                }
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "likeforlike" } }, [
                _vm._v("I Just Require a Like For Like Quote")
              ])
            ]),
            _vm._v(" "),
            _c("li", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.franking_quote_type,
                    expression: "franking_quote_type"
                  }
                ],
                attrs: {
                  type: "radio",
                  id: "futureusage",
                  name: "quoterequirements",
                  value: "current_future"
                },
                domProps: {
                  checked: _vm._q(_vm.franking_quote_type, "current_future")
                },
                on: {
                  change: function($event) {
                    _vm.franking_quote_type = "current_future"
                  }
                }
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "futureusage" } }, [
                _vm._v(
                  "I Require a Quote Based On Our Current And Future Usage Requirements?"
                )
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("error-modal", [
          _vm._v(
            "\n      When opting for a like for like quote we provide options from all manufacturers which are the modern day like for like comparative machines to that of which you curently have in place.\n      "
          ),
          _c("br"),
          _vm._v(
            "\n      When opting for a quote based on current and future usage requirements, we automatically provide suitable options based on this. This may mean we present lower or higher specification models to that of which is already in use.\n    "
          )
        ]),
        _vm._v(" "),
        _c("info-modal", [
          _vm._v(
            "\n      When opting for a like for like quote we provide options from all manufacturers which are the modern day like for like comparative machines to that of which you curently have in place.\n      "
          ),
          _c("br"),
          _vm._v(
            "\n      When opting for a quote based on current and future usage requirements, we automatically provide suitable options based on this. This may mean we present lower or higher specification models to that of which is already in use.\n    "
          )
        ])
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "inputPanel",
        class: { inputPanel__error: _vm.invalidFields.postage_spend_custom }
      },
      [
        _vm._m(8),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "inputPanel__col inputPanel__input inputPanel__input--groupFull inputPanel__input--selectaproduct"
          },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.postage_spend_custom,
                  expression: "postage_spend_custom"
                },
                {
                  name: "positive-numbers-only",
                  rawName: "v-positive-numbers-only"
                }
              ],
              staticClass: "inputLarge",
              attrs: {
                type: "number",
                name: "monthlypostage",
                id: "monthlypostage",
                placeholder: "Enter Value"
              },
              domProps: { value: _vm.postage_spend_custom },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.postage_spend_custom = $event.target.value
                }
              }
            })
          ]
        ),
        _vm._v(" "),
        _c("error-modal", [
          _vm._v(
            "\n      Please confirm the typical amount that you would top up your franking machine each month, if you don't top up every month please simply take your annual spend and divide it by twelve.\n    "
          )
        ]),
        _vm._v(" "),
        _c("info-modal", [
          _vm._v(
            "\n      Please confirm the typical amount that you would top up your franking machine each month, if you don't top up every month please simply take your annual spend and divide it by twelve.\n    "
          )
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "inputPanel__col inputPanel__question" }, [
      _c("label", [
        _vm._v("Is this current solution still in a lease contract?")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "inputPanel__col inputPanel__info" }, [
        _c("div", { staticClass: "infoIcon" }, [
          _vm._v("\n          i\n        ")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "inputPanel__col inputPanel__question" }, [
      _c("label", [
        _vm._v(
          "Which indicia does your franking machine currently print i.e. town circle frank or mail mark frank?"
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "inputPanel__col inputPanel__info" }, [
        _c(
          "div",
          { staticClass: "infoIcon", attrs: { "data-tip": "Info here" } },
          [_vm._v("\n          i\n        ")]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "towncircle" } }, [
      _c("span", [_vm._v("Town Circle")]),
      _vm._v(" "),
      _c("img", {
        attrs: {
          src: require("../../../../../../static/styles/mailkit/img/towncircle.png"),
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "mailmark" } }, [
      _c("span", [_vm._v("Mailmark")]),
      _vm._v(" "),
      _c("img", {
        attrs: {
          src: require("../../../../../../static/styles/mailkit/img/mailmark.png"),
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "inputPanel__col inputPanel__question" }, [
      _c("label", [
        _vm._v("Do you currently pay for postage in advance or arrears?")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "inputPanel__col inputPanel__info" }, [
        _c(
          "div",
          { staticClass: "infoIcon", attrs: { "data-tip": "Info here" } },
          [_vm._v("\n          i\n        ")]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "inputPanel__col inputPanel__question" }, [
      _c("label", [
        _vm._v(
          "\n        Choose your current machine manufacturer and model from the list provided?\n      "
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "inputPanel__col inputPanel__info" }, [
        _c(
          "div",
          { staticClass: "infoIcon", attrs: { "data-tip": "Info here" } },
          [_vm._v("\n          i\n        ")]
        )
      ]),
      _vm._v(" "),
      _c("label", [
        _vm._v(
          "\n        Some 3rd party resellers rename machines, so if you are unsure please contact us for support or use the images provided to help you confirm your choice.\n      "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "inputPanel__col inputPanel__question" }, [
      _c("label", [
        _vm._v(
          "What service cover do you currently have from Quadient (Neopost)?"
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "inputPanel__col inputPanel__info" }, [
        _c(
          "div",
          { staticClass: "infoIcon", attrs: { "data-tip": "Info here" } },
          [_vm._v("\n          i\n        ")]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "inputPanel__col inputPanel__question" }, [
      _c("label", [_vm._v("Please confirm your quote requirements:")]),
      _vm._v(" "),
      _c("div", { staticClass: "inputPanel__col inputPanel__info" }, [
        _c(
          "div",
          { staticClass: "infoIcon", attrs: { "data-tip": "Info here" } },
          [_vm._v("\n          i\n        ")]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "inputPanel__col inputPanel__question" }, [
      _c("label", [
        _vm._v("Please enter your typical monthly postage spend. ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "inputPanel__col inputPanel__info" }, [
        _c(
          "div",
          { staticClass: "infoIcon", attrs: { "data-tip": "Info here" } },
          [_vm._v("\n          i\n        ")]
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-143c0b60", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-143c0b60","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Quotes/Form/Step-1/Conditionals/Form_UsesFrankingMachine.vue
// module id = null
// module chunks = 